import * as api from "../../../api/authApi";

export default {
  // eslint-disable-next-line no-unused-vars
  login({ commit }, formData) {
    return api.login(formData);
  },
};
